import { useContext, useMemo } from "react";

import { InputChoicesContext } from "./InputChoicesContext/InputChoicesContext";

export function useInputChoices() {
  const context = useContext(InputChoicesContext);

  if (!context) {
    throw new Error(
      "useInputChoices must be used within an InputChoicesContextProvider."
    );
  }

  return useMemo(() => context, [context]);
}
